module.exports = __webpack_public_path__ + "static/media/Test3.e50fcdcc.bmp";